import { render, staticRenderFns } from "./getBcmsAll.vue?vue&type=template&id=f0b2008e"
import script from "./getBcmsAll.vue?vue&type=script&lang=js"
export * from "./getBcmsAll.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports